// --- GraphQL Query Strings ---

export const GQL_PING = `query { ping }`;

export const GQL_SCHOOL_YEAR_CALENDAR = `
  query GetSchoolYearCalendar($districtId: String!, $schoolYear: Int!) {
    schoolYearCalendar(districtId: $districtId, schoolYear: $schoolYear) {
      districtId
      schoolYear
      name
      startDate
      endDate
      academicBreakPeriods {
        name
        breakType
        startDate
        endDate
      }
    }
  }
`;

export const GQL_ASSESSMENT_CALENDAR = `
  query GetAssessmentCalendar($schoolId: String!, $schoolYear: Int!) {
    assessmentCalendar(schoolId: $schoolId, schoolYear: $schoolYear) {
      schoolId
      schoolYear
      startDate
      boyWindow
      moyWindow
      eoyWindow
      periods {
        name
        periodIdentifier
        startDate
        endDate
        schoolYear
        tags
      }
    }
  }
`;

export const GQL_GET_CURRENT_PERIOD = `
  query GetCurrentPeriod($schoolId: String!) {
    getCurrentPeriod(schoolId: $schoolId) {
      name
      periodIdentifier
      startDate
      endDate
      schoolYear
      tags
    }
  }
`;

export const GQL_GET_PERIOD_FOR_DATE = `
  query GetPeriodForDate($schoolId: String!, $date: DateOnly!) {
    getPeriodForDate(schoolId: $schoolId, date: $date) {
      name
      periodIdentifier
      startDate
      endDate
      tags
    }
  }
`;

export const GQL_GET_PERIOD = `
  query GetPeriod($userId: Long!, $date: DateOnly!) {
    getPeriod(userId: $userId, date: $date) {
      name
      periodIdentifier
      startDate
      endDate
      tags
    }
  }
`;

export const GQL_GET_CURRENT_SCHOOL_YEAR_CALENDAR = `
  query getCurrentSchoolYearCalendar($districtId: String!, $schoolId: String!) {
    getCurrentSchoolYearCalendar(districtId: $districtId, schoolId: $schoolId) {
        districtId
        schoolId
        schoolYear
        name
        startDate
        endDate
    }
  }
`;

export const GQL_GET_PERIOD_BY_ID = `
  query GetPeriodById(
    $districtId: String
    $schoolId: String
    $periodId: Int!
    $schoolYear: Int
  ) {
    getPeriodById(
      districtId: $districtId
      schoolId: $schoolId
      periodId: $periodId
      schoolYear: $schoolYear
    ) {
      periodIdentifier
      name
      associatedNormPeriod
      startDate
      endDate
      schoolYear
      tags
    }
  }
`;

// --- GraphQL Mutation Strings ---

export const GQL_UPSERT_SCHOOL_YEAR_CALENDAR = `
  mutation UpsertSchoolYearCalendar($calendar: SchoolYearCalendarInput!) {
    upsertSchoolYearCalendar(calendar: $calendar) {
      districtId
      schoolYear
      name
      startDate
      endDate
      academicBreakPeriods {
        name
        breakType
        startDate
        endDate
      }
    }
  }
`;

export const GQL_UPSERT_ASSESSMENT_CALENDAR = `
  mutation UpsertAssessmentCalendar($calendar: AssessmentCalendarInput!) {
    upsertAssessmentCalendar(calendar: $calendar) {
      districtId
      schoolId
      schoolYear
      startDate
      boyWindow
      moyWindow
      eoyWindow
      periods {
        periodIdentifier
        name
        associatedNormPeriod
        startDate
        endDate
        schoolYear
        tags
      }
      extendedPeriods {
        parentIdentifier
        startDate
        endDate
      }
    }
  }
`;